export const ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST = 'ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST';
export const ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS = 'ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS';
export const ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL = 'ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL';

export const ACTION_LOAD_AFFILIATE_TOOLS__REQUEST = 'ACTION_LOAD_AFFILIATE_TOOLS__REQUEST';
export const ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS = 'ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS';
export const ACTION_LOAD_AFFILIATE_TOOLS__FAIL = 'ACTION_LOAD_AFFILIATE_TOOLS__FAIL';

export const ACTION_LOAD_ROTATING_BANNER__REQUEST = 'ACTION_LOAD_ROTATING_BANNER__REQUEST';
export const ACTION_LOAD_ROTATING_BANNER__SUCCESS = 'ACTION_LOAD_ROTATING_BANNER__SUCCESS';
export const ACTION_LOAD_ROTATING_BANNER__FAIL = 'ACTION_LOAD_ROTATING_BANNER__FAIL';

export const ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST = 'ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST';
export const ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS = 'ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS';
export const ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL = 'ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL';

export const ACTION_LOAD_CUSTOM_BANNERS__REQUEST = 'ACTION_LOAD_CUSTOM_BANNERS__REQUEST';
export const ACTION_LOAD_CUSTOM_BANNERS__SUCCESS = 'ACTION_LOAD_CUSTOM_BANNERS__SUCCESS';
export const ACTION_LOAD_CUSTOM_BANNERS__FAIL = 'ACTION_LOAD_CUSTOM_BANNERS__FAIL';

export const ACTION_ADD_CUSTOM_BANNER = 'ACTION_ADD_CUSTOM_BANNER';
export const ACTION_CREATE_CUSTOM_BANNER__REQUEST = 'ACTION_CREATE_CUSTOM_BANNER__REQUEST';
export const ACTION_CREATE_CUSTOM_BANNER__SUCCESS = 'ACTION_CREATE_CUSTOM_BANNER__SUCCESS';
export const ACTION_CREATE_CUSTOM_BANNER__FAIL = 'ACTION_CREATE_CUSTOM_BANNER__FAIL';

export const ACTION_EDIT_CUSTOM_BANNER__REQUEST = 'ACTION_EDIT_CUSTOM_BANNER__REQUEST';
export const ACTION_EDIT_CUSTOM_BANNER__SUCCESS = 'ACTION_EDIT_CUSTOM_BANNER__SUCCESS';
export const ACTION_EDIT_CUSTOM_BANNER__FAIL = 'ACTION_EDIT_CUSTOM_BANNER__FAIL';

export const ACTION_DELETE_CUSTOM_BANNER__REQUEST = 'ACTION_DELETE_CUSTOM_BANNER__REQUEST';
export const ACTION_DELETE_CUSTOM_BANNER__SUCCESS = 'ACTION_DELETE_CUSTOM_BANNER__SUCCESS';
export const ACTION_DELETE_CUSTOM_BANNER__FAIL = 'ACTION_DELETE_CUSTOM_BANNER__FAIL';

export const ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL = 'ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL';
export const ACTION_ADD_PROMOTED_SITES = 'ACTION_ADD_PROMOTED_SITES';

export const ACTION_ADD_SELECTED_PARAMS = 'ACTION_ADD_SELECTED_PARAMS';
export const ACTION_CLEAR_SELECTED_PARAMS = 'ACTION_CLEAR_SELECTED_PARAMS';
